import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SabisChatbotComponent } from '../shared/components/sabis-chatbot/sabis-chatbot.component';

@Component({
    selector: 'app-authenticated-layout',
    templateUrl: './authenticated-layout.component.html',
    styleUrl: './authenticated-layout.component.scss',
    standalone: true,
    imports:[RouterOutlet, SabisChatbotComponent]
})
export class AuthenticatedLayoutComponent {

}
